import { Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';

import { DECISION_MODEL_STATE_ENUMERATION } from './decision-model.enumeration';
import { ROUTES_CONSTANTS } from '@shared/configs';

export const redirectDecisionModel = ({
  state,
  injector,
}: {
  state?: DECISION_MODEL_STATE_ENUMERATION;
  injector: Injector;
}) => {
  const ngZone = injector.get(NgZone);
  const router = injector.get(Router);

  const redirect = redirectDecisionModelDictionary[state];

  if (redirect) {
    ngZone.run(() => {
      router.navigate([redirect()]);
    });
  }
};

export const redirectDecisionModelDictionary: Partial<Record<DECISION_MODEL_STATE_ENUMERATION, <T>(args?: T) => void>> =
  {
    [DECISION_MODEL_STATE_ENUMERATION.REJECTED]: () => ROUTES_CONSTANTS.REJECTED,
    [DECISION_MODEL_STATE_ENUMERATION.DECLINE]: () => ROUTES_CONSTANTS.REJECTED,
    [DECISION_MODEL_STATE_ENUMERATION.GRAY_ZONE]: () => ROUTES_CONSTANTS.GRAY_ZONE,
    [DECISION_MODEL_STATE_ENUMERATION.GZPRR]: () => ROUTES_CONSTANTS.GRAY_ZONE,
    [DECISION_MODEL_STATE_ENUMERATION.ON_GRAY_ZONE]: () => ROUTES_CONSTANTS.GRAY_ZONE,
    [DECISION_MODEL_STATE_ENUMERATION.ON_GRAY_ZONE_PROCESS]: () => ROUTES_CONSTANTS.GRAY_ZONE,
    [DECISION_MODEL_STATE_ENUMERATION.DECLINED]: () => ROUTES_CONSTANTS.REJECTED,
  };
